import React from 'react';

interface DeliveryStatusProps {
  channel?: string;
  deliveryStatus?: string;
  deliveredAt?: string;
  deliveryError?: string;
}

const DeliveryStatus: React.FC<DeliveryStatusProps> = ({ 
  channel, 
  deliveryStatus, 
  deliveredAt, 
  deliveryError 
}) => {
  if (!channel || channel === 'CHAT') {
    return null;
  }

  const getChannelIcon = (channel: string) => {
    switch (channel) {
      case 'SMS':
        return '📱';
      case 'EMAIL':
        return '📧';
      case 'VOICE':
        return '📞';
      default:
        return '💬';
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'DELIVERED':
        return '✅';
      case 'SENT':
        return '✅';
      case 'PENDING':
        return '⏳';
      case 'FAILED':
        return '❌';
      default:
        return '⏳';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'DELIVERED':
        return 'Delivered';
      case 'SENT':
        return 'Sent';
      case 'PENDING':
        return 'Sending...';
      case 'FAILED':
        return 'Failed';
      default:
        return 'Sending...';
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'DELIVERED':
        return 'text-green-600';
      case 'SENT':
        return 'text-green-600';
      case 'PENDING':
        return 'text-yellow-600';
      case 'FAILED':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <div className="flex items-center gap-1 text-xs mt-1">
      <span className="text-gray-500">
        {getChannelIcon(channel)} Sent via {channel}
      </span>
      <span className={`${getStatusColor(deliveryStatus || 'PENDING')} flex items-center gap-1`}>
        {getStatusIcon(deliveryStatus || 'PENDING')}
        {getStatusText(deliveryStatus || 'PENDING')}
      </span>
      {deliveredAt && (
        <span className="text-gray-400">
          at {new Date(deliveredAt).toLocaleTimeString()}
        </span>
      )}
      {deliveryError && (
        <span className="text-red-500 text-xs" title={deliveryError}>
          ⚠️
        </span>
      )}
    </div>
  );
};

export default DeliveryStatus;
